import React from 'react';
import { connect } from 'react-redux';
import { has } from 'lodash';
import { hasReportingPermission } from 'selectors/pathBuilder';
import { routes } from 'constants/config';
import { Spinner } from 'ui';
import ReportingBlock from './Partials/ReportingBlock';
import ReportingBlockHeader from './Partials/ReportingBlockHeader';
import ReportingStat from './Partials/ReportingStat';
import ReportingStatGroup from './Partials/ReportingStatGroup';
import DataProvider from './Partials/DataProvider';
import CompletionPercentage from './CompletionPercentage';

const OverdueBadge = ({ count, href }) => (
  <div className="d-f ai-c">
    <div className="Pill Pill--smaller Pill--danger f-smooth mr-4">{count}</div>
    <a className="c-brand-blue fz-bigger" href={href}>
      Overdue
    </a>
  </div>
);

const Assignments = ({ canViewGradingStation, pathId, groupId }) => (
  <DataProvider
    url={routes.PATH_REPORTING.ASSIGNMENTS(pathId)}
    params={{ groupId }}
  >
    {({ data, loading }) => (
      <ReportingBlock>
        <ReportingBlockHeader title="Assignments">
          {has(data, 'overdue.count') && data.overdue.count !== 0 && (
            <OverdueBadge count={data.overdue.count} href={data.overdue.url} />
          )}
        </ReportingBlockHeader>
        {loading && <Spinner />}
        {!loading && (
          <div>
            <ReportingStatGroup>
              <ReportingStat
                label="Complete"
                value={data.completed.count}
                href={data.completed.url}
              />
              <ReportingStat
                label="Incomplete"
                value={data.incomplete.count}
                href={data.incomplete.url}
              />
              <ReportingStat
                label="Steps Awaiting Grade"
                value={data.awaitingGrade.count}
                href={canViewGradingStation ? data.awaitingGrade.url : null}
              />
            </ReportingStatGroup>
            <CompletionPercentage
              completionPercentage={data.completionPercentage}
            />
          </div>
        )}
      </ReportingBlock>
    )}
  </DataProvider>
);

const mapStateToProps = ({ pathBuilder }) => ({
  canViewGradingStation: hasReportingPermission(
    pathBuilder,
    'viewGradingStation',
  ),
  pathId: pathBuilder.id,
  groupId: pathBuilder.reporting.groupId,
});

export default connect(mapStateToProps)(Assignments);
